module.exports = __webpack_public_path__ + "images/花筑院子全景_07.jpg?v=26452372";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_07.jpg
 ** module id = 80
 ** module chunks = 1 2
 **/